import { Button, InlineMessage } from '@pm/ui';

export const SwitchEncounterType = ({
  title,
  instructions,
  callToAction,
  onClick,
}: {
  title: string;
  instructions: string;
  callToAction: string;
  onClick: () => void;
}) => {
  return (
    <InlineMessage
      intent="default"
      title={title}
      instructions={instructions}
      action={
        <Button intent="ghost" onClick={onClick}>
          {callToAction}
        </Button>
      }
    />
  );
};
